import { hoursToMilliseconds } from 'date-fns'
import { Workbox } from 'workbox-window'

import { captureAndLogError } from '@/lib/error'
import history from '@/lib/history'

export function registerServiceWorker() {
	if (import.meta.env.VITE_APP_SKIP_SW_REGISTRATION === 'true') {
		navigator.serviceWorker
			?.getRegistrations()
			.then((registrations) => Promise.all(registrations.map((r) => r.unregister())))
			.catch(captureAndLogError)
		return
	}

	const wb = new Workbox(import.meta.env.BASE_URL + 'sw.js')

	wb.addEventListener('controlling', () => {
		history.listen(() => {
			window.location.reload()
		})
	})

	wb.register().then((registration) => {
		if (!registration) {
			return
		}

		registration.update().then(() => {
			setInterval(() => {
				registration.update()
			}, hoursToMilliseconds(1))
		})
	})
}
